// src/redux/services/SezInfoSlice.js
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  mapSezinfoResponse,
  mapSezinfoRequest,
} from "@/redux/mappers/Export/CreateNewJob/SezInfoMappers";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";  
import { mapInvoiceSupplier } from "@/redux/mappers/Import/CreateNewJob/InvoiceSupplierMapper";

export const invoiceSupplierApi = createApi({
  reducerPath: "invoiceSupplierApi",
  baseQuery,
  tagTypes: ["invoiceSupplier"],
  endpoints: (builder) => ({
    // ✅ Fetch by ExportMasterId
    getInvoiceSupplierById: builder.query({
      query: ({id,subId}) => `/import/invoice/supplier/${id}/${subId}`,
      transformResponse: (response) =>{
        const data = mapInvoiceSupplier(response?.data)
        return data;
    } ,
      providesTags: (result, error, id) => [{ type: "invoiceSupplier", id }],
    }),

    // ✅ Update SEZ info (PUT)
    createInvoiceSupplier: builder.mutation({
      query: ({ id, dataId,...data }) => ({
        url: `/import/invoice/supplier/${id}/${dataId}`,
        method: "PUT",
        headers: {
          "X-Request-Id": crypto.randomUUID(),
        },
        body:  data,
      }),
      invalidatesTags: ["invoiceSupplier"],
    }),
  }),
});

export const {
  useLazyGetInvoiceSupplierByIdQuery,
  useCreateInvoiceSupplierMutation,
} = invoiceSupplierApi;


